import { h } from "preact";
import { RoutableProps } from "preact-router";
import { useEffect, useState } from "preact/hooks";
import { getProducts, Product } from "../../api/product-api";
import { route } from "../../App";
import { Snackbar, SnackbarShowCommand } from "../../components/Snackbar";
import { useCommand } from "../../hooks";
import { parseToDateAndFormatIfExists } from "../../utils";
import "./styles.scss";

export function ProductList(props: RoutableProps) {
    const [products, setProducts] = useState(null as null | Product[]);
    const [ordersSearch, setOrdersSearch] = useState("");
    const [page, setPage] = useState(0);
    const [count, setCount] = useState(100);
    const showSnackbarCommand = useCommand<SnackbarShowCommand>();

    useEffect(() => {
        getProducts(page, count).then(async (products) => {
            setProducts(products);
        });
    }, [page, count]);

    if (!products) {
        return <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%; height: 100%">
            <div>Pobieranie danych...</div>
            <div class="loader"></div>
        </div>;
    }

    return <div class="product-list-page">
        <Snackbar doShow={showSnackbarCommand}/>
        {products ? [
            <h1>Produkty</h1>,
            <div class="order-items paper">
                <div class="search">
                    <input class="search-text" placeholder="Wyszukaj..." onInput={(e) => setOrdersSearch(e.currentTarget.value)}/>
                </div>
                <div>
                    <button type="button" class={page <= 0 ? "disabled" : ""} onClick={() => setPage(page - 1)}>Poprzednia strona</button>
                    <button type="button" style="margin-left: 10px;" onClick={() => setPage(page + 1)}>Następna strona</button>
                    <span style="margin-left: 10px;">
                        Ilość wyników: <input type="number" value={count} onChange={(e) => setCount(+e.currentTarget.value)}/>
                    </span>
                </div>

                <table class="orders" style="margin-bottom: 10px; margin-top: 10px;">
                    <thead>
                        <tr>
                            <th class="header">Id</th>
                            <th class="header">Type</th>
                            <th class="header">Serial Number</th>
                            <th class="header">Registered by</th>
                            <th class="header">Registration date</th>
                            <th class="header">Revision</th>
                            <th class="header">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.filter(item => !ordersSearch
                                || (item.productTypeRevision?.productType?.name ? item.productTypeRevision!.productType!.name.toLowerCase().indexOf(ordersSearch.toLowerCase()) >= 0 : false)
                                || item.serialNumber.toLowerCase().indexOf(ordersSearch.toLowerCase()) >= 0
                                || item.creator.email.toLowerCase().indexOf(ordersSearch.toLowerCase()) >= 0
                                || parseToDateAndFormatIfExists(item.createdAt).toLocaleString().indexOf(ordersSearch) >= 0)
                                .map((item) => [
                            <tr>
                                <td>{item.id}</td>
                                <td><button type="button" style="height: 20px; text-transform: initial; font-weight: initial; font-size: 14px;" class="flat borderless" onClick={() => route("/product-type/" + item.productTypeRevision!.productType!.id)}>{item.productTypeRevision?.productType?.name}</button></td>
                                <td>{item.serialNumber}</td>
                                <td>{item.creator.email}</td>
                                <td>{parseToDateAndFormatIfExists(item.createdAt)}</td>
                                <td><button type="button" style="height: 20px; text-transform: initial; font-weight: initial; font-size: 14px;" class="flat borderless" onClick={() => route("/product-type-revision/" + item.productTypeRevision!.id)}>{item.productTypeRevision?.name ? item.productTypeRevision?.name : `<ID: ${item.productTypeRevision?.id}>`}</button></td>
                                <td>{item.description}</td>
                                {/* <td></td> */}
                            </tr>
                        ])}
                    </tbody>
                </table>
            </div>
        ] : null}
    </div>;
}
